import { useQuery } from '@tanstack/react-query';
import { Shield } from 'lucide-react';
import { api, timeAgo } from '../../lib/api';
import { SkeletonList, SectionHead } from '../../components/ui';

export default function AdminAudit() {
  const { data, isLoading } = useQuery({ queryKey: ['audit'], queryFn: () => api.get('/admin/audit').then(r => r.data) });
  return (
    <div className="space-y-3">
      <SectionHead title="Audit log" sub="Every admin action is recorded" />
      {isLoading ? <SkeletonList n={10} h="h-12" /> : (
        <div className="card p-2 space-y-0.5">
          {data.map(a => {
            const meta = typeof a.meta === 'string' ? a.meta : JSON.stringify(a.meta || {});
            return (
              <div key={a.id} className="flex items-center gap-3 p-2 rounded-lg hover:bg-ink-50 text-xs">
                <Shield size={13} className="text-ink-300 shrink-0" />
                <span className="font-black w-32 truncate">{a.action}</span>
                <span className="text-ink-500 font-semibold">@{a.admin_username || '—'}</span>
                <span className="text-ink-400">{a.target_type}#{a.target_id || '—'}</span>
                <span className="flex-1 text-ink-400 font-mono text-[10px] truncate">{meta}</span>
                <span className="text-ink-400 font-semibold whitespace-nowrap">{timeAgo(a.created_at)}</span>
              </div>);
          })}
        </div>
      )}
    </div>
  );
}